export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/CoinsStack.1e1e39fb.svg","height":75,"width":73,"blurWidth":0,"blurHeight":0};